export default __webpack_public_path__ + "static/media/renovations.e087ee1e.svg";